import React, { useEffect, useState } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { CARD_STATUS } from "utils/constants";
import { Button, Toggle } from "components/common";

const CardActionModal = ({
  closeModal,
  handleCardAction,
  cardStatus,
  user_id,
  agent_email
}) => {
  const [notification, setNotification] = useState(true);
  const [reason, setReason] = useState(null);
  const [selectOptions, setSelectOptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [notes, setNotes] = useState({
    agent_email,
    date_of_note: new Date().toISOString()
  });

  useEffect(() => {
    if (selectOptions) {
      setReason(selectOptions.label);
    }
  }, [selectOptions]);

  const reasons = [
    { label: "Bank Account Removal Request" },
    { label: "Autopay Removal Request" },
    { label: "Admin Lock" },
    { label: "Partial Pay Admin Lock" },
    { label: "User Lock" },
    { label: "Fraud Claim" },
    { label: "Unauthorized Transaction" },
    { label: "Lost Card" },
    { label: "Stolen/Compromised Card" },
    { label: "Admin Lock" },
    { label: "Address Change" },
    { label: "Not Received (card)" },
    { label: "Termination Request" }
  ];

  return (
    <div className="py-8 bg-neutral-50 px-12">
      <div>Reason for this change:</div>
      {cardStatus !== CARD_STATUS.LOCKED && (
        <Select
          options={reasons}
          onChange={setSelectOptions}
          defaultValue={selectOptions}
          className="mt-2 mb-4"
        />
      )}
      <textarea
        className="w-full mb-5 p-2"
        onChange={
          cardStatus !== CARD_STATUS.LOCKED
            ? e => setNotes({ ...notes, note: e.target.value })
            : e => setReason(e.target.value)
        }
        placeholder="Optional"
        style={{ height: "100px", width: "100%" }}
      />
      <div className="my-5">
        Notification:
        <Toggle
          className="ml-3"
          active={notification}
          onChange={() => setNotification(!notification)}
          displayState
        />
      </div>
      <div className={errorMessage ? "text-red-600 mb-4" : "hidden"}>
        {errorMessage}
      </div>
      <Button
        className={`mb-6 w-full ${loading ? "opacity-50" : ""}`}
        disabled={loading}
        onClick={() => {
          setLoading(true);
          handleCardAction({
            variables: {
              user_id,
              reason,
              notifyEmail: notification,
              notifyText: notification,
              notes
            }
          }).then(() => {
            setLoading(false);
            closeModal();
          });
        }}
      >
        Submit
      </Button>
    </div>
  );
};

const mapStateToProps = state => ({
  agent_email: state.user.id
});

export default connect(mapStateToProps)(CardActionModal);
